/** @format */
import { isObject } from '@toucan/services/utility/type-checking';

export function objectShallowStringify(obj: Record<string, any>) {
    return Object.entries(obj)
        .map(([key, value]) => `${key}:${value}`)
        .join(',');
}

export function objectShallowEqual(
    obj1: Record<string, any>,
    obj2: Record<string, any>
) {
    return objectShallowStringify(obj1) === objectShallowStringify(obj2);
}

export function flattenObject(
    obj = {},
    transformValue = (v: any) => v,
    parentKey = '',
    result = {}
) {
    for (const key in obj) {
        const keyName = parentKey ? `${parentKey}.${key}` : key;
        // @ts-ignore - Element implicitly has an any type - Touch and Change
        if (isObject(obj[key])) {
            // @ts-ignore - Element implicitly has an any type - Touch and Change
            flattenObject(obj[key], transformValue, keyName, result);
        } else {
            // @ts-ignore - Element implicitly has an any type - Touch and Change
            result[keyName] = transformValue(obj[key]);
        }
    }
    return result;
}
